import type { FooterData, LanguageOption } from "../../types";
import { SiteFooterDesktop } from "./footer/SiteFooterDesktop";
import { SiteFooterMobile } from "./footer/SiteFooterMobile";

/** Site footer component props. */
export interface SiteFooterProps {
  data: FooterData;
  logoSrc: string;
  logoAlt?: string;
  /**
   * Optional language switch for the bottom bar (FR · EN · LN). Controlled, like the
   * header selector: when `languageOptions` has 2+ entries the footer renders an inline
   * switch on the right and calls `onLanguageChange` (the Next.js layer navigates).
   * Omitted in surfaces with no routing (admin preview), where the switch is hidden.
   */
  language?: string;
  languageOptions?: LanguageOption[];
  onLanguageChange?: (code: string) => void;
  /** Builds the locale-prefixed URL for a language code (so the switch renders real links). */
  resolveHref?: (code: string) => string;
}

/** Site footer with desktop and mobile versions. */
export function SiteFooter({
  data,
  logoSrc,
  logoAlt = "APA Parts",
  language,
  languageOptions,
  onLanguageChange,
  resolveHref,
}: SiteFooterProps) {
  return (
    <footer className="apa-surface-dark-bottom apa-edge-glow-top text-white">
      <div className="mx-auto max-w-7xl px-6 md:px-8 py-10 xl:py-12">
        <SiteFooterMobile
          data={data}
          logoSrc={logoSrc}
          logoAlt={logoAlt}
          language={language}
          languageOptions={languageOptions}
          onLanguageChange={onLanguageChange}
          resolveHref={resolveHref}
        />
        <SiteFooterDesktop
          data={data}
          logoSrc={logoSrc}
          logoAlt={logoAlt}
          language={language}
          languageOptions={languageOptions}
          onLanguageChange={onLanguageChange}
          resolveHref={resolveHref}
        />
      </div>
    </footer>
  );
}
